import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useShopQuery = createQueryHook(ShopRendererApiClient.getShop, {
  queryKey: ['shop'],
})
